import { render, staticRenderFns } from "./PagoComercio.vue?vue&type=template&id=56938e4d&"
import script from "./PagoComercio.vue?vue&type=script&lang=js&"
export * from "./PagoComercio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports